import { ComponentProps } from "react"
import { Link } from "blitz"
import { Button, BaseButtonProps } from "./Button"

export interface ButtonLinkProps
  extends BaseButtonProps,
    Omit<ComponentProps<"a">, "href">,
    ComponentProps<typeof Link> {}

export const ButtonLink = ({ href, ...props }: ButtonLinkProps) => {
  return (
    <Link href={href} passHref={true}>
      <Button component="a" {...props} />
    </Link>
  )
}
